import { Text, UnstyledButton, Menu } from '@mantine/core';
import { IconPlus, IconCalendarClock, IconCalendarEvent, IconCalendarX } from '@tabler/icons-react';
import classes from './SchedulingCalendarToolbar.module.css';

interface CalendarActionsProps {
  onOpenAppointment: () => void;
  onOpenAvailability: () => void;
  onOpenBlock: () => void;
}

export default function CalendarActions({ onOpenAppointment, onOpenAvailability, onOpenBlock }: CalendarActionsProps) {
  return (
    <Menu shadow="md" width={200} position="bottom-end">
      <Menu.Target>
        <UnstyledButton className={`${classes.actionGroup} ${classes.actionButton} ${classes.actionItem}`} c="#246A7A">
          <IconPlus size={18} />
          <Text fw={600} ml="5px">
            Add
          </Text>
        </UnstyledButton>
      </Menu.Target>
      <Menu.Dropdown style={{ borderRadius: '16px', maxWidth: '180px' }}>
        <Menu.Item leftSection={<IconCalendarEvent size={18} />} onClick={onOpenAppointment}>
          <Text>Appointment</Text>
        </Menu.Item>
        <Menu.Item leftSection={<IconCalendarClock size={18} />} onClick={onOpenAvailability}>
          <Text>Availability</Text>
        </Menu.Item>
        <Menu.Item leftSection={<IconCalendarX size={18} />} onClick={onOpenBlock}>
          <Text>Block</Text>
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
}
